import React, { useState } from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faTimes, faSave } from '@fortawesome/free-solid-svg-icons';
import './style.css';


interface Originador {
  razao_social: string;
  nome_fantasia: string;
  cnpj: string;
  ativo: boolean;
}


const CadastroAdmin = () => {
  const [modais, setModais] = useState({
    edicao: false,
    novoOriginador: false,
    confirmacaoSaida: false
  });

  const [dadosModais, setDadosModais] = useState({
    originadorParaEdicao: null as Originador | null,
    dadosEdicao: {
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      ativo: true
    },
    novoOriginador: {
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      ativo: true
    }
  });

  const [validacaoErro, setValidacaoErro] = useState({
    originador: {
      razao_social: false,
      nome_fantasia: false,
      cnpj: false
    },
    tentouSalvar: false // Flag para saber se já tentou salvar
  });


  const isAdmin = localStorage.getItem('is_admin') === 'true';

  const mockData: Originador[] = [
    {
      razao_social: 'Cartos Sociedade de Crédito Direto S.A.',
      nome_fantasia: 'Cartos',
      cnpj: '59929098000109',
      ativo: true
    },
    {
      razao_social: 'Viva Crédito S.A.',
      nome_fantasia: 'Viva Crédito',
      cnpj: '59929098000109',
      ativo: true
    },
    {
      razao_social: 'Crédito Direto S.A.',
      nome_fantasia: 'Crédito Direto',
      cnpj: '59929098000109',
      ativo: true
    }
  ];

  const abrirModal = (tipoModal: keyof typeof modais, dados?: any) => {
    setModais(prev => ({ ...prev, [tipoModal]: true }));

    if (dados) {
      setDadosModais(prev => ({
        ...prev,
        ...dados
      }));
    }
  };

  const fecharModal = (tipoModal: keyof typeof modais) => {
    setModais(prev => ({ ...prev, [tipoModal]: false }));

    if (tipoModal === 'edicao') {
      setDadosModais(prev => ({
        ...prev,
        originadorParaEdicao: null,
        dadosEdicao: {
          razao_social: '',
          nome_fantasia: '',
          cnpj: '',
          ativo: true
        }
      }));
    } else if (tipoModal === 'novoOriginador') {
      setDadosModais(prev => ({
        ...prev,
        novoOriginador: {
          razao_social: '',
          nome_fantasia: '',
          cnpj: '',
          ativo: true
        }
      }));
    }
  };

  const abrirModalEdicao = (originador: Originador) => {
    abrirModal('edicao', {
      originadorParaEdicao: originador,
      dadosEdicao: {
        razao_social: originador.razao_social,
        nome_fantasia: originador.nome_fantasia,
        cnpj: originador.cnpj,
        ativo: originador.ativo
      }
    });
  };


  const abrirModalNovoAdministrador = () => {
    abrirModal('novoOriginador');
  };


  const salvarEdicao = () => {
    if (dadosModais.originadorParaEdicao) {
      console.log('Salvando edição:', dadosModais.dadosEdicao);
      fecharModal('edicao');
    }
  };


  const salvarNovoOriginador = () => {
    // Marcar que tentou salvar
    setValidacaoErro(prev => ({ ...prev, tentouSalvar: true }));

    // Validação dos campos obrigatórios
    const originadorValido = validarOriginador();

    if (originadorValido) {
      console.log('Criando novo originador:', dadosModais.novoOriginador);
      fecharModal('novoOriginador');
    } else {
      // Definir erros de validação visual
      const novosErros = {
        originador: {
          razao_social: dadosModais.novoOriginador.razao_social.trim() === '',
          nome_fantasia: dadosModais.novoOriginador.nome_fantasia.trim() === '',
          cnpj: dadosModais.novoOriginador.cnpj.trim() === ''
        },
        tentouSalvar: true
      };

      setValidacaoErro(novosErros);
    }
  };

  const validarOriginador = () => {
    const { razao_social, nome_fantasia, cnpj } = dadosModais.novoOriginador;
    return razao_social.trim() !== '' && nome_fantasia.trim() !== '' && cnpj.trim() !== '';
  };


  const handleInputChange = (tipo: 'edicao' | 'novoOriginador', field: string, value: string | boolean) => {
    const key = tipo === 'novoOriginador' ? 'novoOriginador' : `dados${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
    setDadosModais(prev => ({
      ...prev,
      [key]: {
        ...prev[key as keyof typeof prev],
        [field]: value
      }
    }));
  };


  return (
    <ErrorBoundary>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h5 className="card-title">Cadastro de Administradores</h5>
        {isAdmin && (
          <button
            className="fn-button fn-button--emphasized"
            onClick={abrirModalNovoAdministrador}
          >
            <div className="fn-button__text">
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
              Novo Administrador
            </div>
          </button>
        )}
      </div>
      <Table>
        <thead>
          <tr>
            <th>CNPJ</th>
            <th>Razão Social</th>
            <th>Nome Fantasia</th>
            {isAdmin && <th>Editar</th>}
          </tr>
        </thead>
        <tbody>
          {mockData.map((item, index) => (
            <tr key={index}>
              <td>{item.cnpj}</td>
              <td>{item.razao_social}</td>
              <td>{item.nome_fantasia}</td>
              <td>
                {isAdmin && (
                  <button
                    className="fn-button fn-button--icon fn-button--secondary"
                    onClick={() => abrirModalEdicao(item)}
                    title="Editar administrador"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faEdit} />
                    </div>
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>


      {modais.edicao && dadosModais.originadorParaEdicao && (
        <div className="modal-overlay" onClick={() => fecharModal('edicao')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Editar Administrador - {dadosModais.originadorParaEdicao.nome_fantasia}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('edicao')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Razão Social</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.razao_social}
                  onChange={(e) => handleInputChange('edicao', 'razao_social', e.target.value)}
                  placeholder="Digite a razão social"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Nome Fantasia</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.nome_fantasia}
                  onChange={(e) => handleInputChange('edicao', 'nome_fantasia', e.target.value)}
                  placeholder="Digite o nome fantasia"
                />
              </div>
              <div className="form-group">
                <label className="form-label">CNPJ</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.cnpj}
                  onChange={(e) => handleInputChange('edicao', 'cnpj', e.target.value)}
                  placeholder="00.000.000/0000-00"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('edicao')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarEdicao}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.novoOriginador && (
        <div className="modal-overlay" onClick={() => fecharModal('novoOriginador')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Novo Administrador</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('novoOriginador')}
                title="Fechar"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label form-label--required">Razão Social</label>
                <input
                  type="text"
                  className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.originador.razao_social ? 'form-input--error' : ''}`}
                  value={dadosModais.novoOriginador.razao_social}
                  onChange={(e) => handleInputChange('novoOriginador', 'razao_social', e.target.value)}
                  placeholder="Digite a razão social"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label form-label--required">Nome Fantasia</label>
                <input
                  type="text"
                  className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.originador.nome_fantasia ? 'form-input--error' : ''}`}
                  value={dadosModais.novoOriginador.nome_fantasia}
                  onChange={(e) => handleInputChange('novoOriginador', 'nome_fantasia', e.target.value)}
                  placeholder="Digite o nome fantasia"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label form-label--required">CNPJ</label>
                <input
                  type="text"
                  className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.originador.cnpj ? 'form-input--error' : ''}`}
                  value={dadosModais.novoOriginador.cnpj}
                  onChange={(e) => handleInputChange('novoOriginador', 'cnpj', e.target.value)}
                  placeholder="00.000.000/0000-00"
                  required
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('novoOriginador')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarNovoOriginador}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}


    </ErrorBoundary>
  );
};

export default CadastroAdmin;